// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://nyijtkdiwmxanhlealjv.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im55aWp0a2Rpd214YW5obGVhbGp2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njk3MDc1NzMsImV4cCI6MjA4NTI4MzU3M30.LrXTAP_6m0mccFkltavNaTtx2mvBpyBpuU3S8VZxoAE";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});